export default __webpack_public_path__ + "static/media/TresMilAteSeisMilPorMes.58a32e77.svg";